import {Component, ReactElement} from 'react';

interface ErrorBoundaryProps {
  fallback: ReactElement;
}

class ErrorBoundary extends Component<ErrorBoundaryProps> {
  state = {hasError: false, error: null};

  static getDerivedStateFromError(error: {message: string}) {
    return {
      hasError: true,
      error,
    };
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
